var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "placeOrder warp" },
    [
      _c("a-spin", { attrs: { spinning: _vm.spinning } }, [
        _c(
          "div",
          {
            staticStyle: {
              "font-size": "18px",
              "font-weight": "600",
              color: "#333333",
              "margin-bottom": "20px"
            }
          },
          [_vm._v("请确认订单信息")]
        ),
        _vm._v(" "),
        _vm.shopsData
          ? _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      background: "#cccccc4f",
                      padding: "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        style:
                          "width:" +
                          (_vm.shopsData.shopsData.productDetailData
                            .timeSkuStatus
                            ? "40"
                            : "30") +
                          "%;padding-left:20px;"
                      },
                      [_vm._v("商品信息")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        style:
                          "width:" +
                          (_vm.shopsData.shopsData.productDetailData
                            .timeSkuStatus
                            ? "10"
                            : "30") +
                          "%;text-align:center;"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.shopsData.shopsData.productDetailData
                              .timeSkuStatus
                              ? "单价(元/" +
                                  _vm.shopsData.shopsData.productDetailData
                                    .timeSkuName +
                                  ")"
                              : "单价(元)"
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        style:
                          "width:" +
                          (_vm.shopsData.shopsData.productDetailData
                            .timeSkuStatus
                            ? "10"
                            : "30") +
                          "%;text-align:center;"
                      },
                      [_vm._v("数量")]
                    ),
                    _vm._v(" "),
                    _vm.shopsData.shopsData.productDetailData.timeSkuStatus
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              width: "20%",
                              "text-align": "center"
                            }
                          },
                          [
                            _vm._v(
                              "租赁时间(单位/" +
                                _vm._s(
                                  _vm.shopsData.shopsData.productDetailData
                                    .timeSkuName
                                ) +
                                ")"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        style:
                          "width:" +
                          (_vm.shopsData.shopsData.productDetailData
                            .timeSkuStatus
                            ? "20"
                            : "30") +
                          "%;text-align:center;"
                      },
                      [_vm._v("金额(元)")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.shopsData.shopsData.shortShopCar.products, function(
                  item,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        padding: "20px 10px",
                        border: "1px solid #E5E5E5FF",
                        "border-top": "none"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          style:
                            "width:" +
                            (_vm.shopsData.shopsData.productDetailData
                              .timeSkuStatus
                              ? "40"
                              : "30") +
                            "%;display:flex;align-items:stretch;"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100px",
                                height: "100px",
                                overflow: "hidden"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    item.image ||
                                    _vm.shopsData.shopsData.productDetailData
                                      .images[0],
                                  height: "100%",
                                  alt: "",
                                  srcset: ""
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "justify-content": "space-between",
                                "box-sizing": "border-box",
                                padding: "10px 10px",
                                width: "calc(100% - 100px)"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    "font-weight": "bold"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.shopsData.shopsData.productDetailData
                                        .productName
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "13px",
                                    color: "#767676"
                                  }
                                },
                                [
                                  _c("div", [_vm._v(_vm._s(item.skuName))]),
                                  _vm._v(" "),
                                  item.extraSkuName
                                    ? _c("div", [
                                        _vm._v(_vm._s(item.extraSkuName))
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          style:
                            "width:" +
                            (_vm.shopsData.shopsData.productDetailData
                              .timeSkuStatus
                              ? "10"
                              : "30") +
                            "%;text-align:center;"
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.price) + "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          style:
                            "width:" +
                            (_vm.shopsData.shopsData.productDetailData
                              .timeSkuStatus
                              ? "10"
                              : "30") +
                            "%;text-align:center;"
                        },
                        [
                          _vm._v(
                            "\n          x" + _vm._s(item.buyNum) + "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.shopsData.shopsData.productDetailData.timeSkuStatus
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                width: "20%",
                                "text-align": "center"
                              }
                            },
                            [
                              _c("div", [
                                _vm._v("起始日期:" + _vm._s(item.timeArea[0]))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("结束日期:" + _vm._s(item.timeArea[1]))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          style:
                            "width:" +
                            (_vm.shopsData.shopsData.productDetailData
                              .timeSkuStatus
                              ? "20"
                              : "30") +
                            "%;text-align:center;"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.totalPrice) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.shopsData.shopsData.shortShopCar.products.length == 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                          height: "200px",
                          "margin-bottom": "-10px",
                          "font-size": "20px",
                          color: "#939393"
                        }
                      },
                      [_vm._v("\n        您暂未选择商品哦\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#F7F7F7FF",
                      padding: "10px 20px",
                      margin: "20px 0"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 6,
                        placeholder: "如有其它需求,请备注~",
                        maxlength: "300",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.textarea,
                        callback: function($$v) {
                          _vm.textarea = $$v
                        },
                        expression: "textarea"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          background: "#F1F2F7FF",
                          padding: "10px 20px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { width: "60%", "text-align": "left" }
                          },
                          [
                            _c("span", [
                              _vm._v("已选规格 "),
                              _c(
                                "b",
                                {
                                  staticStyle: {
                                    "font-size": "18px",
                                    margin: "0 4px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.shopsData.shopsData.shortShopCar
                                        .products.length
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" 种")
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v("总计数量 "),
                                _c(
                                  "b",
                                  {
                                    staticStyle: {
                                      "font-size": "18px",
                                      margin: "0 4px"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.getCurTotalNum()))]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "auto",
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "baseline"
                                }
                              },
                              [
                                _c("span", [_vm._v("需付款:")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#FF4747FF",
                                      "margin-left": "4px"
                                    }
                                  },
                                  [_vm._v("¥")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "20px",
                                      color: "#FF4747FF",
                                      margin: "0 15px 0 2px"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.getCurTotalPrice()))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  "background-color": "#F77B0BFF",
                                  "font-size": "15px",
                                  color: "#ffffff",
                                  height: "50px",
                                  margin: "-10px -20px -10px 0",
                                  padding: "0 20px",
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.groupBuyNow()
                                  }
                                }
                              },
                              [_vm._v("\n              提交订单\n            ")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-4ca296c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4ca296c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/confirmPay_serv/index.vue
// module id = null
// module chunks = 